import type { DripsyColor } from "@utils";
import { useDripsyColor } from "@utils";
import * as React from "react";
import Svg, { G, Path } from "react-native-svg";

function ConfirmIcon({ size, color }: { size: number; color: DripsyColor }) {
  const finalColor = useDripsyColor({ color });
  return (
    <Svg width={size} height={size} viewBox="0 0 16 16">
      <G stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <G id="Intro" transform="translate(-17.000000, -127.000000)" fill={finalColor} fillRule="nonzero">
          <G id="check-mark" transform="translate(17.000000, 127.000000)">
            <Path
              d="M11.5363769,5.46154784 C11.7805176,5.70568847 11.7805176,6.10144044 11.5363769,6.345459 L7.34350588,10.5384522 C7.09936525,10.7824707 6.70373534,10.7824707 6.45959472,10.5384522 L4.46362306,8.54235841 C4.21948244,8.29833984 4.21948244,7.90258787 4.46362306,7.65856934 C4.70764159,7.41442872 5.10339356,7.41442872 5.34741213,7.65856934 L6.90148925,9.2126465 L10.6524658,5.46154784 C10.8966064,5.21752931 11.2923584,5.21752931 11.5363769,5.46154784 L11.5363769,5.46154784 Z M16,8 C16,12.4219971 12.4213867,16 8,16 C3.57800294,16 0,12.4213867 0,8 C0,3.57800294 3.57861328,0 8,0 C12.4219971,0 16,3.57861328 16,8 Z M14.75,8 C14.75,4.26892091 11.7305908,1.25 8,1.25 C4.26892091,1.25 1.25,4.26940919 1.25,8 C1.25,11.7310791 4.26940919,14.75 8,14.75 C11.7310791,14.75 14.75,11.7305908 14.75,8 Z"
              id="Shape"
            />
          </G>
        </G>
      </G>
    </Svg>
  );
}
export default ConfirmIcon;
